// Consumption Analysis Trends Line Chart

import React from "react";
import ReactECharts from "echarts-for-react";

interface ChartProps {
  reportData?: Array<{
    meterId: string;
    requestsReceived: number;
    readsShared: number;
    [key: string]: any;
  }>;
}

const ConsumerConsumptionLineChart = ({ reportData }: ChartProps) => {
  const randomAverageData = Array.from({ length: 31 }, () =>
    (Math.random() * 20 + 20).toFixed(2)
  );
  const randomCurrentData = randomAverageData.map((avg) =>
    (Math.random() * Number(avg)).toFixed(2)
  );

  const generateDays = () => {
    const daysInMonth = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      0
    ).getDate();
    return Array.from({ length: daysInMonth }, (_, i) => (i + 1).toString());
  };

  const days = generateDays();

  const options = {
    xAxis: {
      type: "category",
      data: days,
      axisLabel: {
        color: "#181B25",
        fontSize: 11,
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: (value: number) => `${value}%`,
        color: "#5F6368",
        fontSize: 9,
      },
      max: 40,
      splitLine: {
        show: false,
        lineStyle: {
          color: "#e0e0e0",
        },
      },
    },
    tooltip: {
      trigger: "axis",
      backgroundColor: "#181B25",
      borderWidth: 1,
      borderColor: "#181B25",
      formatter: () => {
        return `
        <div style="display:flex; gap: 10px; padding: 5px 10px; align-items:center; border-radius: 3px;">
        <div>
        <p style="font-size: 13px; font-weight: 400; line-height: 12px; letter-spacing: 0.32px; color: #ffffff;">6% (240 Kw/h)</p>
        <p style="font-size: 9px; font-weight: 400; line-height: 12px; letter-spacing: 0.32px;  color: #ffffff; margin-top:5px ;">Consumption</p>
        </div>
      </div>
        `;
      },
    },
    grid: {
      left: "2%",
      right: "2%",
      bottom: "3%",
      containLabel: true,
    },
    legend: {
      data: [
        { name: "Consumption", icon: "roundRect" },
        { name: "Average Consumption", icon: "roundRect" },
      ],
      left: "12",
      top: "12",
      itemWidth: 15,
      itemHeight: 15,
      itemGap: 15,
      textStyle: {
        fontFamily: "Figtree",
        fontSize: 10,
        fontWeight: 400,
        lineHeight: 11.72,
        letterSpacing: "0.02em",
        color: "#4C5269",
        textAlign: "left",
      },
      selectedMode: true,
    },

    series: [
      {
        name: "Consumption",
        data: randomCurrentData,
        type: "line",
        smooth: false,
        lineStyle: {
          width: 1,
          color: "#29CBFF",
        },
        itemStyle: {
          color: "#29CBFF",
        },
        symbol: "none",
        emphasis: {
          disabled: true,
        },
      },
      {
        name: "Average Consumption",
        data: randomAverageData,
        type: "line",
        smooth: false,
        lineStyle: {
          width: 1,
          color: "#ECEDF7",
        },
        itemStyle: {
          color: "#ECEDF7",
        },
        symbol: "none",
        emphasis: {
          disabled: true,
        },
      },
    ],
  };

  return <ReactECharts option={options} style={{ height: "98%" }} />;
};

export default ConsumerConsumptionLineChart;
